// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const opacities = {
  transparent: 0,
  dim: 0.4,
  semiOpaque: 0.5,
  opaque: 1
} as const;

export default opacities;
